import { useCallback, useState } from 'react';

export const useHover = (
  activeOnStart = false,
): [boolean, { onMouseEnter: () => void; onMouseLeave: () => void }] => {
  const [isHovering, setIsHovering] = useState(activeOnStart);

  const onMouseEnter = useCallback(() => {
    setIsHovering(true);
  }, [setIsHovering]);

  const onMouseLeave = useCallback(() => {
    setIsHovering(false);
  }, [setIsHovering]);

  return [
    isHovering,
    {
      onMouseEnter,
      onMouseLeave,
    },
  ];
};
